import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

function AuthGuard({ children, path, permissions = [] }: any) {
  const user: any = useSelector((state: any) => state.account.user);

  if (!user) {
    return <Redirect to="/users/sign_in" />;
  }

  // new logic for permissions.
  // TODO La idea es refactorizar el codigo de permisos de acceso para centrar toda la logica en este componente. Tambien unir los permisos en solo 1 (acceso a la vista)
  if (permissions.length) {
    const can = permissions.some((p: any) => user.permissions.includes(p));
    if (!can) return <Redirect to="/unauthorized" />;
  }

  const not_role = user.role === 'not_role';
  const analyst = user.permissions.includes('analyst_user');

  if (not_role && analyst) {
    const allowed_paths = ['/reporteria', '/search'];
    if (allowed_paths.includes(path)) {
      return children;
    } else {
      return <Redirect to="/search?unauthorized=true" />;
    }
  }

  if (not_role && path !== '/unauthorized') {
    return <Redirect to="/unauthorized" />;
  }

  return children;
}

export default AuthGuard;
